import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("shb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const RECORD_TYPES = {
  Adliye: ["Gelen Evrak", "Açılacak Dava", "Açılacak İcra Takibi", "Arabuluculuk Başvurusu", "Diğer"],
  "TÜRKPATENT": ["Gelen Evrak", "Yapılacak İş", "Diğer"],
  "Diğer": ["Gelen Evrak", "Yapılacak İş"],
};

export const SECTIONS = ["Adliye", "TÜRKPATENT", "Diğer"];

export const STATUSES = ["Yapılacak", "Devam Ediyor", "Tamamlandı"];
export const PRIORITIES = ["Normal", "Önemli", "Acil"];
export const ASSIGNEES = ["Umut Sağlam"];

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const bucketLabel = {
  overdue: "Geciken",
  today: "Bugün",
  upcoming: "Yaklaşan",
  later: "İleri tarih",
  none: "Tarihsiz",
};
